import { apiBase } from "./base";

const apiLsrVor = {
	client: apiBase.get_client(),
	url: "/projects/",

	getLsrVorForConnection({ projectId }) {
		return this.client.get(this.url + projectId + "/lsr_vor_connection/", apiBase.get_headers());
	},

	manageLsrVorItemConnection({ projectId, body }) {
		return this.client.post(this.url + projectId + "/lsr_vor_connection/", body, apiBase.get_headers());
	},

	getLsrTableData({ lsrId }) {
		return this.client.get("/smetdocs/local_estimates/tree_vor_connect/" + lsrId + "/", apiBase.get_headers());
	},

	getVorTableData({ vorId }) {
		return this.client.get("/smetdocs/vor/tree_lsr_connect/" + vorId + "/", apiBase.get_headers());
	},

	getLsrXmlWithVorConnection({ lsrId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "text/xml";
		return this.client.get("/smetdocs/local_estimates/xml/with_vor_connections/" + lsrId + "/", headers);
	},

	updateStrQTFLinkByRealLink({ projectId, body }) {
		return this.client.post(this.url + projectId + "/update_str_qtf_links_by_real_links/", body, apiBase.get_headers());
	},

	getAllVorAndLsrXmlWithVorConnection({ projectId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + projectId + "/lsr_vor_connection_pack/", headers);
	},
};

export default apiLsrVor;
